import * as React from 'react'
import {useAuthInfo, useValidationState} from '@oc/shell-core'

export const useLogout = () => {
    const {signOut} = useAuthInfo()
    const validationState = useValidationState()

    return React.useCallback(async () => {
        if (validationState.isDirty()) {
            validationState.setErrorMessage()
            return
        }

        await signOut()
        localStorage.clear()
    }, [validationState, signOut])
}
